import { Component, Input, OnDestroy, OnInit } from "@angular/core";

@Component({
  selector: "receipt-table-row-header",
  templateUrl: "./receipt-table-row-header.component.html",
  styleUrls: [
    "../receipt-table-row/receipt-table-row.component.scss",
    "./receipt-table-row-header.component.scss",
  ],
})
export class ReceiptTableRowHeader {
  static BatchPaymentHeader = {
    collectedBy: "נגבה ע״י",
    eventName: "ארוע",
    receiptDate: "תאריך קבלה",
    amountCharged: "סכום שנגבה",
    childName: "שם החניכ/ה",
    paymentType: "אופן תשלום",
    amountToDeposit: "נותר להפקדה",
    actions: "הצמדה",
  };
  public batchPaymentHeader = ReceiptTableRowHeader.BatchPaymentHeader;
  @Input("indentToScrollBar") public indentToScrollBar: boolean = false;
}



// WEBPACK FOOTER //
// ./src/app/admin/receipt/receipt-table-row-header/receipt-table-row-header.component.ts